import {WorkflowClient} from '@client/workflow-client'
import {MessageBox} from '@components/message-box'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import React from 'react'
import {Lang} from 'yougile-lang'
import {
  Action,
  DataObjectId,
  findIdInWorkflow,
  WorkflowConfig,
  Workflow,
  workflowToConfig
} from 'yougile-model'
import {ActionButton} from '../workflow-components'

interface Props {
  boardId: DataObjectId
}

const runCreateAction = async (
  props: StartProps,
  action: Action,
  title: string,
  inputs: {[id: string]: unknown}
) => {
  const {workflow} = props
  const actionId = findIdInWorkflow(workflow.ids, 'create', action.name)
  try {
    await WorkflowClient.runAction({
      workflowId: workflow.id,
      actionId,
      inputs: {title, ...inputs}
    })
    MessageBox.show(Lang.msg.workflow.actionDone, 'success')
  } catch (e) {
    MessageBox.show(e.message ?? Lang.msg.error, 'danger')
  }
}

const StartActions = (props: StartProps) => {
  const {config} = props
  const createActions = config.create?.actions ?? []
  return (
    <>
      {createActions.map(action => {
        const create = (text: string, inputs: {[id: string]: any}) => {
          void runCreateAction(props, action, text, inputs)
        }
        return (
          <ActionButton
            showTitle
            onSubmit={create}
            key={action.name}
            {...{action, ...props}}
          />
        )
      })}
    </>
  )
}

interface StartProps {
  workflow: Workflow
  config: WorkflowConfig
}

export const WorkflowCreate = (props: Props) => {
  useSyncEventUpdateEffect('current', {filter: globals.getCompanyId()})

  const workflows = WorkflowClient.getBoardWorkflows(props.boardId)
  const all = workflows.map(workflow => ({
    config: workflowToConfig(workflow),
    workflow
  }))
  const withCreate = all.filter(c => !!c?.config?.create)

  if (!withCreate.length) {
    return null
  }
  return (
    <div className="mb-8 flex">
      {withCreate.map(c => (
        <StartActions key={c.workflow.id} {...c} />
      ))}
    </div>
  )
}
